import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'sid',
      type: 'input',
      label: '账号ID',
      placeholder: '请输入账号ID'
    },
    {
      field: 'sname',
      type: 'input',
      label: '账号名称',
      placeholder: '请输入账号名称'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'uname',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'createdTimeType',
      type: 'select',
      label: '客户添加时间',
      clearable: true,
      options: [
        {title: '全部', value: ''},
        {title: '1个月 - 2个月', value: '1'},
        {title: '2个月 - 3个月', value: '2'},
        {title: '3个月以上', value: '3'}
      ]
    },
    {
      field: 'rangeType',
      type: 'select',
      label: '最后消息据今',
      clearable: true,
      options: [
        {title: '1个月 - 2个月', value: ''},
        {title: '2个月 - 3个月', value: '1'},
        {title: '3个月 - 4个月', value: '2'},
        {title: '4个月 - 5个月', value: '3'},
        {title: '5个月 - 6个月', value: '4'},
        {title: '6个月以上', value: '5'},
        {title: '2个月以上', value: '6'},
        {title: '从未回复过', value: '7'}
      ]
    },
    {
      field: 'deptName',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门',
      filterable: true,
      options: [
        {title: '全部', value: ''},
        {title: '518', value: '518'},
        {title: '投教', value: '投教'}
      ]
    },
    {
      field: 'removeD',
      type: 'switch',
      label: '排除成、删',
      activeValue: '1',
      inActiveValue: '0'
    }
  ]
}
